"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Container = function (_a) {
    var children = _a.children, open = _a.open, align = _a.align, onClose = _a.onClose, appendClassname = _a.appendClassname;
    var openClass = open ? 'storybook-dropdowns-container-open' : 'storybook-dropdowns-container-close';
    var alignClass = align ? 'storybook-dropdowns-container-' + align : '';
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: openClass + " " + alignClass + " " + appendClassname }, children),
        open && react_1.default.createElement("div", { className: 'storybook-dropdowns-overlay', onClick: onClose }));
};
exports.Container = Container;
exports.Container.propTypes = {
    children: prop_types_1.default.any,
    open: prop_types_1.default.bool,
    align: prop_types_1.default.string
};
exports.Container.defaultProps = {
    align: 'left',
    appendClassname: ''
};
